import Vue from 'vue'
import ElementUI from 'element-ui'
import ElementUILocaleJa from 'element-ui/lib/locale/lang/ja'
import VueSession from 'vue-session'
import IdleVue from 'idle-vue'
import Storage from 'vue-web-storage'

import App from './app.vue'
import router from './extentions/router'
import addValidator from './extentions/validator'
import addFilters from './extentions/filters'
import addCommonComponents from './extentions/components'

import '../static/css/theme.scss'

let SkyFoxVue = Vue

SkyFoxVue.config.productionTip = false
// Vue.config.devtools = true

SkyFoxVue.use(ElementUI, {locale: ElementUILocaleJa})

SkyFoxVue.use(Storage, {
  prefix: 'skyfox_',
  drivers: ['session']
})
SkyFoxVue.use(VueSession)
SkyFoxVue.use(IdleVue, {eventEmitter: new SkyFoxVue(), idleTime: 720 * 60 * 1000})

SkyFoxVue = addValidator(SkyFoxVue)
SkyFoxVue = addFilters(SkyFoxVue)
SkyFoxVue = addCommonComponents(SkyFoxVue)

// eslint-disable-next-line no-new
new SkyFoxVue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>',
  onIdle () {
    this.$session.destroy()
    this.$router.push('/login?isIdle=true')
  }
})



// WEBPACK FOOTER //
// ./src/main.js